
import { NotFoundScreen } from '@/screens/public/NotFoundScreen';
import { useProjectContext } from '@/providers/ProjectContextProvider';
import { FC, ReactNode } from 'react';

type EnterpriseLicenseGuardProps = {
  children: ReactNode;
};

export const EnterpriseLicenseGuard: FC<EnterpriseLicenseGuardProps> = ({
  children,
}) => {
  const projectContext = useProjectContext();
  if (!projectContext?.hasLicense) {
    return <NotFoundScreen />;
  }

  return <>{children}</>;
};
